import React from "react";
import NoResults from "./NoResults";
const FilterResultsEmpty = () => <NoResults text="No results found. Try a different day, genre or head back home"/>;
export default FilterResultsEmpty;
